import { marked } from 'marked';

export const parseMarkdown = (markdown: string): string | Promise<string> => {
    return markdown ? marked.parse(markdown) : '';
};
